import {
  BookOpen,
  Building2,
  FileBarChart,
  GraduationCap,
  Landmark,
  School,
  Target,
  Users,
} from "lucide-react";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";
import LaporanKeuanganSection from "@/components/LaporanKeuanganSection";
import ExternalLinkSection from "@/components/ExternalLinkSection";
import KepegawaianSection from "@/components/KepegawaianSection";

// Tautan data eksternal per halaman (dropdown + tombol "Lihat Data").
const EXTERNAL_LINKS = {
  kemahasiswaan: [
    {
      slug: "mahasiswa-2025",
      label: "Lihat Data Kemahasiswaan LLDIKTI Wilayah VII Tahun 2025",
      href: "https://data.kemdiktisaintek.go.id/dashboard/mahasiswa?tahun=2025&kelompok%5B%5D=PTS&lembaga%5B%5D=LLDIKTI+VII",
    },
  ],
  "dosen-tendik": [
    {
      slug: "dosen-pts-2025",
      label: "Lihat Data Dosen PTS LLDIKTI Wilayah VII Tahun 2025",
      href: "https://data.kemdiktisaintek.go.id/dashboard/dosen?tahun=2025&kelompok%5B%5D=PTS&lembaga%5B%5D=LLDIKTI+VII",
    },
  ],
  kelembagaan: [
    {
      slug: "kelembagaan-pts-2025",
      label: "Lihat Data Kelembagaan PTS LLDIKTI Wilayah VII Tahun 2025",
      href: "https://data.kemdiktisaintek.go.id/dashboard/kelembagaan?tahun=2025&kelompok%5B%5D=PTS&lembaga%5B%5D=LLDIKTI+VII",
    },
  ],
};

// Konfigurasi halaman menu "Data dan Laporan". Konten masih kosong —
// akan dikembangkan kemudian; cukup isi bagian konten di komponen ini.
export const DATA_LAPORAN = [
  {
    path: "/pengelolaan-program-dan-anggaran",
    title: "Pengelolaan Program dan Anggaran",
    Icon: Target,
    kind: "keuangan",
  },
  {
    path: "/pengelolaan-kepegawaian",
    title: "Data Pegawai",
    Icon: Users,
    kind: "kepegawaian",
  },
  { path: "/sarana-dan-prasarana", title: "Sarana dan Prasarana", Icon: Building2 },
  { path: "/dosen-dan-tendik", title: "Dosen", Icon: GraduationCap, kind: "dosen-tendik" },
  { path: "/kelembagaan", title: "Kelembagaan", Icon: Landmark, kind: "kelembagaan" },
  { path: "/akademik", title: "Akademik", Icon: BookOpen },
  {
    path: "/kemahasiswaan",
    title: "Kemahasiswaan",
    Icon: School,
    kind: "kemahasiswaan",
  },
];

export default function DataLaporanPage({ title, Icon = FileBarChart, kind }) {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Data dan Laporan
          </p>
          <h1
            data-testid="data-laporan-title"
            className="mt-6 max-w-3xl font-display text-4xl font-semibold leading-[1.05] md:text-6xl"
          >
            {title}
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        {kind === "keuangan" ? (
          <Reveal delay={0.15}>
            <LaporanKeuanganSection />
          </Reveal>
        ) : kind === "kepegawaian" ? (
          <Reveal delay={0.15}>
            <KepegawaianSection />
          </Reveal>
        ) : EXTERNAL_LINKS[kind] ? (
          <Reveal delay={0.15}>
            <ExternalLinkSection items={EXTERNAL_LINKS[kind]} />
          </Reveal>
        ) : (
          <Reveal delay={0.15}>
            <div
              data-testid="data-laporan-empty"
              className="mt-12 rounded-3xl border border-dashed border-[#BBDCF3] bg-[#FBFDFF] px-6 py-16 text-center md:px-12 md:py-20"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EFF6FC]">
                <Icon aria-hidden="true" className="h-7 w-7 text-[#1479BF]" />
              </div>
              <h2 className="mt-6 font-display text-xl font-semibold md:text-2xl">
                Konten Sedang Dalam Pengembangan
              </h2>
              <p className="mx-auto mt-3 max-w-md text-[13px] leading-relaxed text-slate-500">
                Data dan dokumen {title.toLowerCase()} akan dipublikasikan pada
                halaman ini.
              </p>
            </div>
          </Reveal>
        )}
      </main>
      <Footer compact />
    </div>
  );
}
